module.exports = __webpack_public_path__ + "static/media/1-a.abb3aad6.png";